import { useEffect, useState } from 'react';

/**
 * Milliseconds since `startedAt`, ticking while it is set and zero once it is
 * not.
 *
 * Tenths, because the readout shows tenths and anything faster is work nobody
 * can read. The interval lives in whichever component displays the clock rather
 * than in the chat provider, so a ticking turn re-renders one line instead of
 * the whole transcript.
 *
 * The tick carries the turn it belongs to. Storing the timestamp alone would
 * let a new turn's first frame render the *previous* turn's elapsed time for
 * the 100ms before the interval caught up, which is a wrong number rather than
 * a late one.
 */
export function useElapsed(startedAt: number | null): number {
  const [tick, setTick] = useState(() => ({ startedAt, now: Date.now() }));

  useEffect(() => {
    if (startedAt === null) return;
    const timer = setInterval(() => setTick({ startedAt, now: Date.now() }), 100);
    return () => clearInterval(timer);
  }, [startedAt]);

  if (startedAt === null) return 0;
  const now = tick.startedAt === startedAt ? tick.now : startedAt;
  return Math.max(0, now - startedAt);
}
